import React, { useEffect } from 'react';
import {Route, Switch, useHistory} from 'react-router-dom';
import routes from './config/routes';
import ReactGA from 'react-ga'; // Google Analytics


import 'bootstrap/dist/css/bootstrap.min.css';

const trackingId = process.env.REACT_APP_GA_TRACKING_ID;

ReactGA.initialize(trackingId, {debug: false});

const App = () => {

    const history = useHistory();

    useEffect(() => {
        history.listen(location => {
            ReactGA.set({page: location.pathname});
            ReactGA.pageview(location.pathname);
        });
    }, [history]);

    return (
        <Switch>
            {
              routes.map((route, index) => (
                <RouteWithSubRoutes key={index} {...route} />
              ))
            }
        </Switch>
    );
};

const RouteWithSubRoutes = (route) => {
  return (
    <Route 
      path={route.path}
      exact={route.exact}
      render={props => <route.component routes={route.routes} {...props} />}
    />
  );
};

export default App;
